import Tabs from '../../components/Tabs/Tabs'
import { phobsPropertiesTabs } from './phobsPropertiesTabs'

export const PhobsProperties = () => {
	return (
		<Tabs
			tabs={phobsPropertiesTabs}
		/>
	)
}